// extracted by mini-css-extract-plugin
export var avatarContainer = "_aq-0";
export var avatarTypingWave = "_aq-i";
export var gray = "_aq-f";
export var green = "_aq-c";
export var icon = "_aq-9";
export var image = "_aq-1";
export var lg = "_aq-6";
export var md = "_aq-5";
export var presenceDot = "_aq-b";
export var red = "_aq-d";
export var sm = "_aq-4";
export var status = "_aq-a";
export var typingDot = "_aq-h";
export var typingPill = "_aq-g";
export var xl = "_aq-7";
export var xs = "_aq-3";
export var xxl = "_aq-8";
export var xxs = "_aq-2";
export var yellow = "_aq-e";